import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import {connect} from 'react-redux';
import {toggleSidebar} from 'admin-on-rest/lib/actions/uiActions';
import AppBar from 'material-ui/AppBar';
import AccountButton from '../buttons/AccountButton';

const FuseAppBar = ({title, toggleSidebar}) => {
    return (
        <AppBar
            title={title}
            iconElementRight={<AccountButton/>}
            onLeftIconButtonClick={toggleSidebar}
        />
    )
};

FuseAppBar.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
        .isRequired,
    toggleSidebar: PropTypes.func.isRequired,
};

const enhance = compose(
    connect(
        null,
        {
            toggleSidebar: toggleSidebar,
        }
    )
);

export default enhance(FuseAppBar);



// WEBPACK FOOTER //
// ./src/Fuse/admin/FuseAppBar.js